/*
 * @Description: 路由
 * @Date: 2025-06-03 11:19:16
 */
export const route = [
  /**************经营类***************/
  {
    path: '/main/settlement-mgmt-list',
    name: 'settlement-mgmt-list',
    meta: {
      title: '项目结算管理',
      taxType: 1
    },
    component: () => import('../views/settlement-mgmt-list/index')
  },
  {
    path: '/main/settlement-mgmt-details',
    name: 'settlement-mgmt-details',
    meta: {
      title: '查看明细',
      taxType: 1,
      parentPath: '/main/settlement-mgmt-list'
    },
    component: () => import('../views/settlement-mgmt-details/index')
  },
  {
    path: '/main/settlement-mgmt-generate',
    name: 'settlement-mgmt-generate',
    meta: {
      title: '生成订单',
      taxType: 1,
      parentPath: '/main/settlement-mgmt-list'
    },
    component: () => import('../views/settlement-mgmt-generate/index')
  },

  /**************劳务类***************/
  {
    path: '/main/settlement-mgmt-list-labourt',
    name: 'settlement-mgmt-list-labourt',
    meta: {
      title: '项目结算管理',
      taxType: 2
    },
    component: () => import('../views/settlement-mgmt-list/index')
  },
  {
    path: '/main/settlement-mgmt-details-labourt',
    name: 'settlement-mgmt-details-labourt',
    meta: {
      title: '查看明细',
      taxType: 2,
      parentPath: '/main/settlement-mgmt-list-labourt'
    },
    component: () => import('../views/settlement-mgmt-details/index')
  },
  {
    path: '/main/settlement-mgmt-generate-labourt',
    name: 'settlement-mgmt-generate-labourt',
    meta: {
      title: '生成订单',
      taxType: 2,
      parentPath: '/main/settlement-mgmt-list-labourt'
    },
    component: () => import('../views/settlement-mgmt-generate/index')
  }
];
